import React from 'react'
import CalculatorContainer from '../container/calculatorContainer'

function HomeCalculator() {
  return (
    <div>

        <div className="p-5 backgroundJumbotron1">
          <h1 className="pt-3 display-5 fw-bold text-light">Calculadora</h1>
          <p className="pb-3 col-md-5 fs-2 text-light fw-light">Mide gratis la huella de carbono de tu hogar.</p>
        </div>

        <div className='p-5 d-flex flex-column align-items-center'>

            <div className="mb-5 pb-2">
                <h2 className="col-12 py-5 tittleText fw-bold">Calcula tu huella de carbono</h2>
                <p className="grey fs-4">Esta calculadora de huella de carbono, te permitirá conocer las emisiones de gases
                de efecto invernadero producidas durante el ultimo año en tu hogar.</p>
                <p className="grey fs-4">Los resultados obtenidos se muestran en kg de Carbono (CO2) equivalentes, la cual es la medida estandarizada.</p>
                <p className="grey fs-4">Estos mismos resultados no representan ninguna validez para estudios medio ambientales y deben usarse solo para uso personal o educativo, si deseas asesoría para estudios ambientales y cuantificar las emiones de tu empresa, evento o producto, contáctanos.</p>
            </div>

            <div>
                <div className='rounded-4 p-4  military1Transparent mb-3'>
                    
                       <CalculatorContainer/>

                </div>
            </div>

        </div>


    </div>
  )
}

export default HomeCalculator
